import { country } from '../configuration';
export const phoneInternationalCodeMapping: Record<country, string> = {
  fr: '+33',
  en: '+44',
  es: '+34',
  br: '+55',
  et: '+372',
  fi: '+358',
  el: '+30',
  it: '+39',
  lt: '+370',
  nb: '+47',
  pt: '+351',
  ru: '+7',
  de: '+49',
  sv: '+46',
  hu: '+36',
};
